import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
// Initialize Meta Pixel
initMetaPixel('1904779843432668');
render(<App data-id="element-378" />, document.getElementById('root'));